import IncTextField from '../fields/inc-text-field/inc-text-field.component';
import { useTranslation } from 'react-i18next';
import { Button } from '@mui/material';
import IncTextFieldMasked from '../fields/inc-text-field-masked/inc-text-field-masked.component';
import { Customer } from 'api/user-domain/user-domain.types';
import { useWatch } from 'react-hook-form';
import { useVerifyEmailLink } from 'pages/crm/customers/customer-details/customer-card/verify-email-link-menu-item/verify-email-link-menu-item.hooks';

type CustomersFromProps = {
  data: Customer;
};

const CustomersForm = ({ data }: CustomersFromProps) => {
  const { t } = useTranslation();

  const { triggerVerifyEmail, isLoading, isSuccess } = useVerifyEmailLink();

  const emailValue = useWatch({ name: 'email' });

  return (
    <>
      <IncTextField
        name="firstName"
        label={t('page.customers.form.customer.firstName')}
        data-testid="CustomersForm.IncTextField.FirstName"
      />
      <IncTextField
        name="lastName"
        label={t('page.customers.form.customer.lastName')}
        data-testid="CustomersForm.IncTextField.LastName"
      />
      <IncTextField
        name="email"
        label={t('page.customers.form.customer.emailAddress')}
        data-testid="CustomersForm.IncTextField.Email"
      />
      {data?.status === 'VERIFICATION_PENDING' && (
        <Button
          variant="text"
          sx={{
            textDecoration: 'underline',
            marginTop: -1,
            ':hover': {
              textDecoration: 'underline',
            },
          }}
          onClick={() => triggerVerifyEmail({ userId: data.userId })}
          disabled={emailValue !== data.email || isLoading || isSuccess}
        >
          {t('page.customers.form.customer.verifyEmail.link')}
        </Button>
      )}
      <IncTextField
        name="phoneNumber"
        label={t('page.customers.form.customer.phoneNumber')}
        data-testid="CustomersForm.IncTextField.phoneNumber"
      />
      <IncTextFieldMasked
        name="dateOfBirth"
        label={t('page.customers.form.customer.dateOfBirth')}
        data-testid="CustomersForm.IncTextField.dateOfBirth"
        mask="00-00"
        placeholder="MM-DD"
        definitions={{
          '#': /[1-9]/,
        }}
      />
    </>
  );
};

export default CustomersForm;
